import VisibilityIcon from "@mui/icons-material/Visibility";
import { IconButton } from "@mui/material";
import WindowService from "../../services/windowService";

/**
 * Button component that opens the product passport dialog
 */
export const ProductPassportButton = ({ productId, size, color = "primary" }) => {
    const handleClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        WindowService.openInNewTab(`/products/passport-window/${productId}/`);
    };

    return (
        <IconButton color={color} onClick={handleClick} size={size}>
            <VisibilityIcon />
        </IconButton>
    );
};
